"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBabyTreeFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M16.945 4.738c1.623.669 2.961 2.069 3.23 3.925 1.073.886 1.823 2.194 1.823 3.749 0 3.065-2.78 5.059-5.556 5.059-.147 0-.293-.006-.438-.016-.81.766-1.864 1.274-3.004 1.463V20h8a1 1 0 110 2H3a1 1 0 110-2h8v-1.082c-1.14-.19-2.193-.698-3.003-1.463a6.16 6.16 0 01-.441.016C4.78 17.47 2 15.477 2 12.41c0-1.556.752-2.865 1.827-3.752.27-1.854 1.608-3.253 3.23-3.92C8.023 3.018 9.98 2 12.001 2s3.978 1.02 4.944 2.738zm-1.359 5.034a1 1 0 11.828 1.82c-1.236.562-2.102 1.616-2.673 2.602a9.16 9.16 0 00-.74 1.638V16a1 1 0 11-2 0v-.129a6.6 6.6 0 00-.582-1.09c-.458-.685-1.009-1.19-1.598-1.297a1 1 0 11.358-1.968c1.259.23 2.15 1.118 2.713 1.885.038-.069.077-.139.118-.209.679-1.172 1.812-2.619 3.576-3.42z' }))); };
exports.default = SvgBabyTreeFilled;
//# sourceMappingURL=BabyTreeFilled.js.map